import React, {useState} from 'react';
import './modal_cookie.scss'

interface IModalCookie{
    active: boolean,
    close: () => void,
    onAccept: () => void
}

const ModalCookie = ({active, close, onAccept}: IModalCookie) => {
    const [closing, setClosing] = useState(false)

    const handleClose = () => {
        onAccept()
        setClosing(true)
    }

    return (
        <>
            {active ?
                    <div className={`modal_cookies_body ${closing ? `modal_cookies_closing` : ''}`} onClick={(e) => e.stopPropagation()}>
                        <div className={'modal_cookies_body_left'}>
                            <p>
                                Наш сайт использует файлы cookie и аналогичные технологии, чтобы обеспечивать корректную работу, улучшать пользовательский опыт, а также анализировать взаимодействие с сайтом.<br/>
                                Подробнее в нашей <a href={'/politika-konfidenczialnosti.pdf'} target={"_blank"} style={{color: '#1934ea'}}>политике конфиденциальности</a>. Продолжая или нажимая «Принять», вы даёте согласие на обработку ваших персональных данных.
                            </p>
                        </div>
                        <div className={'modal_cookies_body_right'}>
                            <button className="button" onClick={handleClose}>
                                Принять
                            </button>
                        </div>
                    </div>
            :
            <></>
            }
        </>
    );
};

export default ModalCookie;